import { render } from "./AdminGestionFinanciere.vue?vue&type=template&id=b0f23faa&scoped=true"
import script from "./AdminGestionFinanciere.vue?vue&type=script&lang=js"
export * from "./AdminGestionFinanciere.vue?vue&type=script&lang=js"

import "./AdminGestionFinanciere.vue?vue&type=style&index=0&id=b0f23faa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0f23faa"]])

export default __exports__